import * as Effects from 'redux-saga/effects'
import { callFetch } from '../../../actions/fetch'
import { INotificationMarkAsRead } from '../../../actions/notification/notifications'
import { fireToastError } from '../../../actions/toasts/fireToast'
import i18n from '../../../i18n'
import { markNotificationsRead } from '../../../models/Notifications'
import { isSyncing } from '../../../reducers/synchronize/selectors/lastSync'
import { NotificationActions } from '../../../reducers/userAccount/actionNames'
import { ActionNames } from '../../../utils/FetchActionsName'
import fetchActionsName from '../../../utils/FetchActionsName/fetchActionsName'

function* markAsRead(action: INotificationMarkAsRead) {
  try {
    const sync = yield Effects.select(isSyncing)
    if (sync) {
      yield Effects.delay(500)
      yield Effects.put(action)
      return
    }
    const actionNames = fetchActionsName(ActionNames.MarkNotificationAsRead)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, markNotificationsRead),
      ),
    ])

    yield Effects.call(service, action.id)
  } catch (e) {
    console.error(e)
    yield Effects.put(fireToastError(i18n.t('error_server_response_2')))
  }
}

export default function*() {
  yield Effects.takeEvery(NotificationActions.MarkAsRead, markAsRead)
}
